// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"8d15b059","237":"baa7927d","493":"8bf16fcb","503":"07d9d5e4"}[chunkId] + ".chunk.js";
};